import script from "./StepNav.vue?vue&type=script&setup=true&lang=js"
export * from "./StepNav.vue?vue&type=script&setup=true&lang=js"

import "./StepNav.vue?vue&type=style&index=0&id=43c5a55c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c5a55c"]])

export default __exports__